import { render, staticRenderFns } from "./FormHeading.vue?vue&type=template&id=0d185dfa&scoped=true&"
import script from "./FormHeading.vue?vue&type=script&lang=js&"
export * from "./FormHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d185dfa",
  null
  
)

export default component.exports